export const WS_APP_LINK_DATA_TYPE_START = 1; // 待受開始
export const WS_APP_LINK_DATA_TYPE_ORDER = 2; // 契約情報
export const WS_APP_LINK_DATA_TYPE_SIGN = 3; // 署名データ
export const WS_APP_LINK_DATA_TYPE_END = 4; // 契約終了
